(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeCtrl', Propriedade);

  Propriedade.$inject = [
    '$scope',
    '$animate',
    'HistoricosService',
    'LoadingService',
    '$route',
    '$routeParams',
    '$location',
    'Flash',
    '$timeout',
    'UsuariosService',
    'DrawPolygonsService',
    'DrawPolygonsObjectService',
    '$q',
    'RecomendacoesService',
    'LeafletService',
    'DadosMeteorologicosService',
    '$rootScope',
    'ContagensService',
    'MessagesService',
    'AspectosGeraisService',
    'OcorrenciasService'
  ];

  /* eslint-disable max-lines-per-function, max-len, max-params, complexity, no-mixed-operators */

  function Propriedade($scope, $animate, HistoricosService, LoadingService, $route, $routeParams, $location,
    Flash, $timeout, UsuariosService, DrawPolygonsService, DrawPolygonsObjectService, $q,
    RecomendacoesService, LeafletService, DadosMeteorologicosService, $rootScope,
    ContagensService, MessagesService, AspectosGeraisService, OcorrenciasService) {
    const vm = this;
    const INIT_STATE_EVENTS = [
      'addRecommendation',
      'edicaoAuditoriaAplicacao',
      'addRecommendationCorrecao',
      'addRecommendationAdubacao'
    ];

    //////////////////////////////////////////
    // Controller data
    vm.ready = false;
    vm.isHistoricoOpen = true;
    vm.filters = {
      date: null,
      gleba: null,
      cultura: null,
      operacao: null,
      usuario: null,
      cultivar: null
    };
    vm.cultivares = {};
    vm.culturasPorGleba = null;
    vm.cultivaresPorGleba = null;
    vm.customGlebaPolygonOptions = null;
    vm.currentSidebar = null;
    vm.focusedGleba = null;
    vm.markers = [];
    vm.polygons = [];
    vm.sidebarData = null;
    vm.calendarDisabled = false;
    vm.polylines = [];
    vm.culturas = [];
    vm.operacoes = [];
    vm.glebas = $rootScope.currentPropriedade.glebas;
    vm.usuarios = [];
    vm.sharedData = {
      culturas: [],
      operacoes: [],
      usuariosWithHistory: [],
      cultivares: []
    };
    vm.imageOverlays = [];
    vm.legendas = null;
    vm.outrasLegendas = null;
    vm.activeHeatmaps = null;
    vm.headMapType = '';
    vm.activeTab = 0;
    vm.historyNotificationCount = 0;
    vm.defaultPolygons = [];
    vm.weatherForecast = null;

    //////////////////////////////////////////
    // Bindable methods
    vm.toggleHistorico = toggleHistorico;
    vm.toggleSidebar = toggleSidebar;
    vm.toggleHistoricoIconClass = toggleHistoricoIconClass;
    vm.activateSidebar = updateActiveSidebar;
    vm.onShowHistoryTab = onShowHistoryTab;
    vm.onCalendarFiltersChange = onCalendarFiltersChange;

    //////////////////////////////////////////
    // Function declarations

    function toggleHistorico() {
      vm.isHistoricoOpen = !vm.isHistoricoOpen;
      toggleElement('.sidebar-historico', vm.isHistoricoOpen);
    }

    function toggleSidebar() {
      toggleElement('propriedade-sidebar', !!vm.currentSidebar);
    }

    function toggleHistoricoIconClass() {
      return `fa-${vm.isHistoricoOpen ? 'angle-double-left' : 'angle-double-right'}`;
    }

    function loadCulturasPeriodo(data = vm.filters.date) {
      return HistoricosService.listCulturasDoPeriodo(data || new Date()).then(function(result) {
        vm.legendas = result.all;
        vm.legendas.push({
          descricao: 'Não definida',
          cor: '#FFF'
        });
        vm.culturasPorGleba = result.porGleba;
      });
    }

    function loadCultivaresPeriodo(data = vm.filters.date) {
      return HistoricosService.listCultivaresDoPeriodo(data || new Date()).then(function(result) {
        const outrasLegendas = result.all;
        outrasLegendas.push({
          descricao: 'Não definida',
          cor: '#FFF'
        });

        vm.cultivares.cultivaresPorGleba = result.porGleba;
        vm.cultivares.legendas = outrasLegendas;

        if (vm.filters.cultivar) {
          changeLegenda(null, vm.filters.cultivar);
        }

        vm.ready = true;
      });
    }

    function activateSidebar(sidebarName) {
      if (!sidebarName) {
        vm.currentSidebar = null;
      } else {
        vm.currentSidebar = sidebarName;
      }

      if (['recommendations', 'tasks', 'addTask'].includes(vm.currentSidebar)) {
        if (!vm.sidebarData) {
          vm.sidebarData = {};
        }
        vm.sidebarData.glebas = vm.glebas;
      } else if (vm.currentSidebar === 'weatherForecast') {
        vm.sidebarData = vm.weatherForecast;
      }

      vm.toggleSidebar();
    }

    function updateActiveSidebar(sidebarName) {
      if (sidebarName === vm.currentSidebar) {
        return updateRouteParams({ sidebar: null });
      }
      updateRouteParams({ sidebar: sidebarName });
    }

    function toggleElement(selector, visible) {
      let result;
      const element = angular.element(selector);
      if (visible) {
        result = $animate.removeClass(element, 'closed');
      } else {
        result = $animate.addClass(element, 'closed');
      }

      result.then(function() {
        $scope.$broadcast('viewportChanged');
      });
    }

    function setFocusedGleba(id) {
      vm.focusedGleba = id;
    }

    function resetMarkers() {
      vm.markers = [];
    }

    function setMarkers(markers) {
      vm.markers = markers.map((marker) => ({
        marker: marker.leafletMarker || marker,
        objeto: marker.objeto,
        infoWindow: marker.infoWindow
      }));
    }

    function resetPolygons() {
      vm.polygons = [];
    }

    function resetPolylines() {
      vm.polylines = [];
    }

    function setPolygons(polygons) {
      vm.polygons = polygons;
    }

    function addPolygons(polygons) {
      vm.polygons = (vm.polygons || []).concat(polygons);
    }

    function removePolygons(polygons = []) {
      const currentPolygons = vm.polygons.slice();
      polygons.forEach((polygon) => {
        const idx = currentPolygons.indexOf(polygon);
        if (idx > -1) {
          currentPolygons.splice(idx, 1);
        }
      });
      vm.polygons = currentPolygons;
    }

    function animateMarker(index, start = true) {
      if (vm.markers[index]) {
        /** @type {Element} */
        const pane = vm.markers[index].marker.getPane();
        const markerElement = pane.children[index];

        if (start) {
          pane.classList.add('has-animated-marker');
          return markerElement.classList.add('animated-marker');
        }
        pane.classList.remove('has-animated-marker');
        markerElement.classList.remove('animated-marker');
      }
    }

    function setImageOverlays(images = []) {
      const glebas = _.uniq(images.map((img) => img.gleba));
      $scope.$broadcast('mapFocusPolygons', glebas);
      vm.imageOverlays = images;
    }

    function eventActivate(name, data) {
      vm.sidebarData = data;
      updateRouteParams({ sidebar: name });
      setFocusedGleba((data.summary || data.activity.gleba).id);
    }

    /**
     * Updates route params with most recent data
     *
     * @param {*} {} all params to update URL
     */
    function updateRouteParams({
      sidebar = vm.sidebar,
      filters = vm.filters,
      activeGleba = vm.focusedGleba
    } = {}) {
      filters = { ...filters }; // avoid messing with outside references (side effects)
      filters.date = filters.date && moment(filters.date).format(MOMENT_DATE_ENGLISH_FORMAT) || null;
      filters.gleba = filters.gleba && filters.gleba.id || null;
      filters.operacao = filters.operacao && filters.operacao.id || null;
      filters.cultura = filters.cultura && filters.cultura.id || null;
      filters.usuario = filters.usuario && filters.usuario.id || null;
      filters.cultivar = filters.cultivar && filters.cultivar.item_id || null;
      const params = {
        ...filters,
        sidebar,
        activeGleba
      };
      $route.updateParams(params);
    }

    /**
     * Makes current view answer to all route updates
     */
    function answerToRouteUpdate() {
      const newFilters = getNewFilters();
      const changedDate = +newFilters.date !== +vm.filters.date;
      if (JSON.stringify(newFilters) !== JSON.stringify(vm.filters)) {
        vm.markers = [];
        vm.polygons = [];
        vm.imageOverlays = [];
        vm.sidebar = null;
      }
      vm.filters = newFilters;
      if (
        $routeParams.propriedade &&
          +$routeParams.propriedade !== $rootScope.currentPropriedade.id &&
          $routeParams.propriedade !== $rootScope.currentPropriedade.uuid
      ) {
        return changePropriedade();
      }
      if (changedDate) {
        loadCulturasPeriodo();
        loadCultivaresPeriodo();
      }
      if ($routeParams.sidebar !== vm.currentSidebar) {
        activateSidebar($routeParams.sidebar);
      }
      setFocusedGleba($routeParams.activeGleba);
    }

    function getCultivar() {
      if ($routeParams.cultivar === 'todas') {
        return {
          descricao: 'Todas',
          item_id: 'todas'
        };
      }

      return $routeParams.cultivar && _.find(vm.sharedData.cultivares, { item_id: +$routeParams.cultivar }) || null;
    }

    /**
     * Gets a new filter objects from params in URL
     *
     * @returns
     */
    function getNewFilters() {
      return {
        date: $routeParams.date && moment($routeParams.date).toDate() || null,
        gleba: $routeParams.gleba && _.find($rootScope.currentPropriedade.glebas, { id: +$routeParams.gleba }) || null,
        operacao: $routeParams.operacao && _.find(vm.sharedData.operacoes, { id: $routeParams.operacao }) || null,
        cultura: $routeParams.cultura && _.find(vm.sharedData.culturas, { id: +$routeParams.cultura }) || null,
        usuario: $routeParams.usuario && _.find(vm.sharedData.usuariosWithHistory, { id: +$routeParams.usuario }) || null,
        cultivar: getCultivar()
      };
    }

    /**
     * Show active heatmap legends
     *
     * @param {any[]} heatmaps all active heatmaps
     * @param {'machine' | 'date' | null} mapType tipo do mapa, machine ou data
     */
    function setActiveHeatmaps({ heatmaps, mapType }) {
      vm.headMapType = mapType;
      vm.activeHeatmaps = heatmaps;
    }

    /**
     * Loads amount of History notifications for red badge
     *
     * @returns {Promise<any[]>} HistoricoServices Promise
     */
    function loadHistoryNotificationCount() {
      return HistoricosService.list();
    }

    /**
     * Loads all shared data (usuarios, culturas, operacoes)
     */
    function loadAllSharedData() {
      return HistoricosService.getAllSelectFilters();
    }

    /**
     * Broadcasts event to activate History tab
     */
    function onShowHistoryTab() {
      $scope.$broadcast('showHistoryTab');
    }

    /**
     * Called when any calendar filter is changed
     *
     * @param {{date?: Date, gleba?: {id: number}, operacao?: {id: number}, usuario?: {id: number}, cultura?: {id: number}}} data all selected filters
     */
    function onCalendarFiltersChange(data) {
      updateRouteParams({ filters: data, activeGleba: (data.gleba && data.gleba.id) || null });
    }

    /**
     * Changes current selected propriedade based on URL
     */
    function changePropriedade() {
      const newPropriedade = $rootScope.getPropriedade(
        isNaN(+$routeParams.propriedade) ? $routeParams.propriedade : +$routeParams.propriedade
      );

      if (!_.isEmpty(newPropriedade)) {
        return $rootScope.setPropriedade(newPropriedade.id);
      }

      $location.path('/');
      Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
    }

    function loadDefaultPolygons(showLoader = false) {
      if (showLoader) {
        LoadingService.showLoading();
      }
      return DrawPolygonsService.list({ somente_carregar_automaticamente: true }).then((polygonsData) => {
        const defaultPolygons = [];
        const promises = polygonsData.data.map((drawPolygon) => DrawPolygonsService.get(drawPolygon.id).then((data) => {
          DrawPolygonsObjectService.convertToObject(data.data || {}, true).polygons.forEach((polygon) => {
            const tooltip = L.tooltip();
            tooltip.setContent(drawPolygon.descricao);
            polygon.bindTooltip(tooltip);

            defaultPolygons.push(polygon);
          });
        }));

        return $q.all(promises).then(() => vm.defaultPolygons = defaultPolygons);
      })
        .finally(() => showLoader && LoadingService.hideLoading());
    }

    function loadAplicacoesAtrasadas() {
      return RecomendacoesService.list({
        gleba: vm.filters.gleba,
        status: { id: 'aberto,em_andamento' }
      }).then((result) => {
        const total = _.filter(result.data, 'atrasada').length;
        if (total > 0) {
          const popup = L.popup({
            className: 'popup-aplicacoes-atrasadas'
          });
          popup.setContent(`<i class="icon-pulverization-fill"></i> <strong class="text-danger">${total}</strong> aplicações atrasadas`);
          /** @type L.LatLngBounds */
          const bounds = LeafletService.boundsFromCoordinates(_.find(vm.glebas, { id: vm.focusedGleba }).coordinates);
          popup.setLatLng(bounds.getCenter());
          popup.addTo(LeafletService.getMap('propriedade-map'));
          popup.openPopup();
        }
      });
    }

    function loadWeatherForecast() {
      // espera um tempo pra não atrapalhar o usuário com mais uma request
      $timeout(() => {
        // não carrega se já estiver com a sidebar aberta
        if (vm.currentSidebar !== 'weatherForecast') {
          vm.weatherForecast = 'loading';
          DadosMeteorologicosService.previsaoDoTempo($rootScope.currentPropriedade.id)
            .then(({ data }) => {
              vm.weatherForecast = data;
            })
            .catch((error) => {
              console.error(error);
              vm.weatherForecast = 'error';
            });
        }
      }, 2000);
    }

    function reloadCalendar() {
      $scope.$broadcast('calendarLoadDates');
    }

    function alterarCultivar(event, registro, cultivar) {
      LoadingService.showLoading();
      $('.tpd-tooltip').remove();

      let changeCultivarFunction;
      if (registro.tipo === 'stand') {
        changeCultivarFunction = ContagensService.changeCultivarStand;
      } else if (registro.tipo === 'anotacao') {
        changeCultivarFunction = AspectosGeraisService.updateCultivar;
      } else if (['inseto', 'invasora', 'doenca', 'nematoide', 'climatica', 'solo', 'manutencao_melhoria', 'inimigo_natural'].includes(registro.tipo)) {
        changeCultivarFunction = OcorrenciasService.updateCultivar;
      } else if (registro.tipo === 'produtividade') {
        changeCultivarFunction = ContagensService.changeCultivarProdutividade;
      }
      if (changeCultivarFunction) {
        changeCultivarFunction(registro, cultivar).then(function() {
          $route.reload();
        }, function() {
          MessagesService.alert('Falha ao alterar a cultivar.');
          LoadingService.hideLoading();
        });
      } else {
        MessagesService.alert('Falha ao alterar a cultivar, não existe tratamento para este tipo de registro.');
        LoadingService.hideLoading();
      }
    }

    function desativarRegistro(event, registro, marker, action) {
      LoadingService.showLoading();

      ContagensService.desativarRegistro(action, registro.registroId).then(function() {
        $route.reload();
      }, function() {
        MessagesService.alert('Falha ao desativar.');
        LoadingService.hideLoading();
      });
    }

    function changeLegenda(event, cultivar) {
      if (!cultivar) {
        vm.outrasLegendas = null;
        vm.cultivaresPorGleba = null;
      } else if (vm.cultivares.cultivaresPorGleba) {
        vm.outrasLegendas = vm.cultivares.legendas;
        if (cultivar.item_id === 'todas') {
          vm.cultivaresPorGleba = vm.cultivares.cultivaresPorGleba;
        } else {
          vm.cultivaresPorGleba = Object.keys(vm.cultivares.cultivaresPorGleba).reduce((group, glebaId) => {
            const cultivarPorGleba = vm.cultivares.cultivaresPorGleba[glebaId];
            const filtered = cultivarPorGleba.ids.indexOf(cultivar.item_id) >= 0;
            group[glebaId] = { ...cultivarPorGleba, filtered: filtered };

            return group;
          }, {});
        }
      }
    }

    //////////////////////////////////////////
    // Controller logic
    LoadingService.showLoading();

    if (!$rootScope.initState) {
      try {
        const stored = window.localStorage.getItem('edit_redirect_data');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (INIT_STATE_EVENTS.includes(parsed.event)) {
            $rootScope.initState = parsed;
            window.localStorage.removeItem('edit_redirect_data');
          }
        }
      } catch (error) {
        console.error('Falha ao ler edit_redirect_data do localStorage', error);
      }
    }

    $scope.$watch('$root.initState', () => {
      if ($rootScope.initState && INIT_STATE_EVENTS.includes($rootScope.initState.event)) {
        vm.sidebarData = $rootScope.initState.params;
      } else {
        vm.sidebarData = null;
      }
    }, true);

    $rootScope.initialize
      .then(() => {
        $location.search('from', null);
        const gleba = $routeParams.activeGleba;
        if (gleba) {
          const propriedade = _.find($rootScope.propriedades, {
            glebas: [
              {
                id: +gleba
              }
            ]
          });
          if (propriedade && propriedade.id !== $rootScope.currentPropriedade.id) {
            $route.updateParams({
              propriedade: propriedade.id
            });
            $timeout(changePropriedade);
            throw new Error('stop loading');
          } else if (!propriedade) {
            $location.path('/');
            Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
            throw new Error('stop loading');
          }
        }
      })
      .then(() => $q.all([
        UsuariosService.list(),
        loadHistoryNotificationCount(),
        loadAllSharedData()
      ]))
      .then(([usuarios, historicos, sharedData]) => {
        vm.usuarios = usuarios.data;

        const prop = _.find(historicos.data, { propriedade: $rootScope.currentPropriedade.id });
        vm.historyNotificationCount = prop.nao_lidas;

        vm.sharedData = {
          culturas: sharedData.culturas,
          operacoes: sharedData.operacoes,
          usuariosWithHistory: sharedData.usuarios,
          cultivares: sharedData.cultivares
        };

        answerToRouteUpdate();
        $scope.$on('$routeUpdate', answerToRouteUpdate);
        return loadCulturasPeriodo();
      })
      .then(() => loadCultivaresPeriodo())
      .then(() => loadDefaultPolygons())
      .then(() => loadWeatherForecast())
      .catch((error) => {
        if (error.message !== 'stop loading') {
          $rootScope.errorRootInitialize();
        }
      })
      .finally(LoadingService.hideLoading);

    $scope.$on('startLoading', () => {
      vm.calendarDisabled = true;
    });
    $scope.$on('stopLoading', () => {
      vm.calendarDisabled = false;
    });
    $scope.$on('setSidebarData', (_event, data) => vm.sidebarData = data);
    $scope.$on('loadDefaultPolygons', () => loadDefaultPolygons(true));
    $scope.$on('reloadCalendar', () => reloadCalendar());

    $scope.$on('activateApplications', (_event, data) => {
      eventActivate('applications', data);
    });
    $scope.$on('activateTasks', (_event, data = null) => {
      eventActivate('tasks', data);
    });

    $scope.$on('setPolylines', (_event, data) => {
      vm.polylines = data.trackings || data;
      if (data.gleba) {
        setFocusedGleba(data.gleba.id);
      }
    });

    $scope.$on('clearMarkers', resetMarkers);
    $scope.$on('setMarkers', (_event, markers) => setMarkers(markers));
    $scope.$on('clearPolygons', resetPolygons);
    $scope.$on('clearPolylines', resetPolylines);
    $scope.$on('setPolygons', (_event, polygons) => setPolygons(polygons));
    $scope.$on('addPolygons', (_event, polygons) => addPolygons(polygons));
    $scope.$on('removePolygons', (_event, polygons) => removePolygons(polygons));
    $scope.$on('openMarkerPopup', (_event, index) => {
      if (typeof index !== 'number') {
        index = _.findIndex(vm.markers, { marker: index });
      }
      vm.markers[index].marker.togglePopup();
    });
    $scope.$on('startAnimatingMarker', (_event, index) => {
      if (typeof index !== 'number') {
        index = _.findIndex(vm.markers, { marker: index });
      }
      animateMarker(index);
    });
    $scope.$on('stopAnimatingMarker', (_event, index) => {
      if (typeof index !== 'number') {
        index = _.findIndex(vm.markers, { marker: index });
      }
      animateMarker(index, false);
    });
    $scope.$on('setImageOverlays', (_event, images) => setImageOverlays(images));
    $scope.$on('singleImageOverlay', (_event, image) => vm.singleImageOverlay = image);
    $scope.$on('setFocusedGleba', (_event, gleba) => setFocusedGleba((gleba || {}).id || gleba));

    $scope.$on('setActiveHeatmaps', (_event, heatmaps) => setActiveHeatmaps(heatmaps));

    $scope.$on('edit_adubacao', (_event, data) => {
      vm.sidebarData = data;
      updateRouteParams({ sidebar: 'addRecommendationAdubacao' });
    });
    $scope.$on('edit_correcao', (_event, data) => {
      vm.sidebarData = data;
      updateRouteParams({ sidebar: 'addRecommendationCorrecao' });
    });

    $scope.$on('activateSidebar', (_event, sidebar, data) => {
      vm.sidebarData = data;
      updateActiveSidebar(sidebar);
    });

    $scope.$on('glebaPolygonClick', (_event, data) => $scope.$broadcast('glebaClick', data));
    $scope.$on('glebaPolygonDblClick', (_event, data) => {
      $route.updateParams({
        gleba: data.gleba.id
      });
      $scope.$apply();
      $timeout(() => {
        vm.focusedGleba = data.gleba.id;
        loadAplicacoesAtrasadas();
      }, 500);
      $scope.$broadcast('glebaDblClick', data);
    });
    $scope.$on('leafletMapClick', (_event, data) => $scope.$broadcast('mapClick', data));

    $scope.$on('resetMap', () => $scope.$broadcast('leafletResetMap'));

    $scope.$on('closePopup', (popup) => $scope.$broadcast('leafletClosePopup', popup));

    $scope.$on('generateTaskInfoWindow', (_event, _gMarker, lMarker) => {
      const data = _.filter(lMarker.objeto.allLeafletMarkers, (marker) => marker.objeto.tipo === lMarker.objeto.tipo);
      if (!vm.sidebarData) {
        vm.sidebarData = {
          addToTask: data
        };
      } else {
        vm.sidebarData.addToTask = data;
      }

      if (vm.sidebar !== 'addTask') {
        updateActiveSidebar('addTask');
      }
    });
    $scope.$on('generateTaskFromOcorrencia', (_event, lMarkers) => {
      vm.sidebarData = {
        addToTask: lMarkers
      };
      if (vm.sidebar !== 'addTask') {
        updateActiveSidebar('addTask');
      }
    });
    $scope.$on('setCultura', (_event, cultura) => {
      $scope.$broadcast('selectCultura', cultura);
    });

    $scope.$on('setCustomGlebaPolygonOptions', (_event, options) => {
      vm.customGlebaPolygonOptions = options;
    });

    $scope.$on('setOutrasLegendas', (_event, data) => vm.outrasLegendas = data);

    $scope.$on('setZoomGlebas', (_event, data) => $scope.$broadcast('mapFocusPolygons', data));

    $scope.$on('clearNotifications', () => {
      vm.historyNotificationCount = 0;
    });

    $scope.$on('$locationChangeStart', (_event, next, current) => {
      const from = current.match(/sidebar=(\w+)/);
      const nextSidebar = next.match(/sidebar=(\w+)/);
      if (from && !next.match(new RegExp(`from=${ from[1]}`)) && nextSidebar) {
        $location.search('from', from[1]);
      } else if (!from || !nextSidebar || nextSidebar === from) {
        $location.search('from', null);
      }

      const nextPropriedade = next.match(/propriedade=(\d+)/);
      if (!nextPropriedade) {
        $location.search('propriedade', $rootScope.currentPropriedade.id);
      }
    });

    $scope.$on('loadedWeatherForecast', (_event, data) => {
      vm.weatherForecast = vm.sidebarData = data;
    });

    $scope.$on('changeCultivar', alterarCultivar);

    $rootScope.$on('desativarRegistro', desativarRegistro);

    $scope.$on('cultivarFilterChanged', changeLegenda);
  }
}());
